// 'use client'

// import Image from 'next/image'
// import Link from 'next/link'
// import { usePathname } from 'next/navigation'
// import { useEffect, useState } from 'react'
// import { useSelector } from 'react-redux'
// import HeaderMenu from '../HeaderMenu'
// import ProductSearchBar from '../../app/explore/(components)/ProductSearchBar'
// import MyAccount from '../misc/MyAccounts'

// const Header = ({ categoryMenu }) => {
//   const [isloaded, setIsloaded] = useState(false)
//   const { user } = useSelector((state) => state?.user)
//   const pathName = usePathname()
//   const [path, setPath] = useState(pathName)

//   useEffect(() => {
//     if (user === null || user) {
//       setIsloaded(true)
//     }
//   }, [user])

//   useEffect(() => {
//     setPath(pathName)
//   }, [pathName])

//   return (
//     path !== '/checkout' &&
//     path !== '/explore' && (
//       <header id="header">
//         <div className="header_navmenu">
//           <div className="site-container">
//             <nav className="nav_wrapper">
//               <div className="m_logo">
//                 <Link href="/" className="navbar__logo">
//                   <Image
//                     className="m_nav_logo desktop_logo"
//                     src="/images/logo.png"
//                     alt="company logo"
//                     width={100}
//                     height={100}
//                   />
//                   <Image
//                     className="m_nav_logo responsive_logo"
//                     src="/images/mobile-logo.png"
//                     alt="company logo"
//                     width={100}
//                     height={100}
//                   />
//                 </Link>
//               </div>

//               <div className="search_myaccount_wrapper">
//                 <div className="search-wrappper">
//                   <div className="res-search-header">
//                     <ProductSearchBar
//                       placeholder={'Search for products, brand and more'}
//                     />
//                   </div>
//                   <Link href={'/explore'}>
//                     <i className="m-icon res-search-icon"></i>
//                   </Link>
//                 </div>
//                 <MyAccount user={user} isloaded={isloaded} />
//               </div>
//             </nav>
//           </div>
//           <HeaderMenu
//             categoryMenu={categoryMenu}
//             user={user}
//             isloaded={isloaded}
//           />
//         </div>
//       </header>
//     )
//   )
// }

// export default Header
'use client'

import Image from 'next/image'
import Link from 'next/link'
import { usePathname, useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ProductSearchBar from '../../app/explore/(components)/ProductSearchBar'
import MyAccount from '../misc/MyAccounts'
import { useMediaQuery } from 'react-responsive'
import HeaderStorePincode from '../HeaderStorePincode'
import HeaderMenu from '../HeaderMenu'
import HeaderSkeleton from '../skeleton/HeaderSkeleton'
import HeaderSearch from '../HeaderSearch'

const Header = ({ categoryMenu }) => {
  const [mounted, setMounted] = useState(false)
  const [isloaded, setIsloaded] = useState(false)
  const [openSearch, setOpenSearch] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false)
  const { user } = useSelector((state) => state?.user)
  const pathName = usePathname()
  const router = useRouter()
  const [path, setPath] = useState(pathName)
  const [isVisible, setIsVisible] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)
  const { cartCount } = useSelector((state) => state?.cart)

  const handleScroll = () => {
    const currentScrollY = window.scrollY
    if (currentScrollY > lastScrollY && currentScrollY > 100) {
      // Adjust 100 for your desired offset
      setIsVisible(false)
    } else {
      setIsVisible(true)
    }
    setLastScrollY(currentScrollY)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [lastScrollY]) // Re-run effect if lastScrollY changes

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1024px)'
  })
  const isNotBigDesktop = useMediaQuery({
    query: '(max-width: 1536px)'
  })
  const isLaptop = useMediaQuery({
    query: '(min-width: 768px)'
  })

  useEffect(() => {
    if (user === null || user) {
      setIsloaded(true)
    }
  }, [user])

  useEffect(() => {
    setPath(pathName)
    setMenuOpen(false)
  }, [pathName])

  const handleLogoClick = (e) => {
    e.preventDefault()
    window.location.href = '/'
  }

  const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'Products', href: '/products/natural-sweetener?CategoryId=2' },
    { label: 'About us', href: '/about-us' },
    { label: 'Proof', href: '/proof' },
    { label: 'Blogs', href: '/blogs' },
    { label: 'Contact us', href: '/contact-us' },
  ]

//   const isActiveLink = (href) =>
//     href === '/' ? pathName === '/' :  href.startsWith("/products").includes(pathName) || pathName.startsWith(href)

const isActiveLink = (href) => {
  const hrefPath = href.split('?')[0] // strip query params like ?CategoryId=2

  return hrefPath === '/'
    ? pathName === '/'
    : pathName === hrefPath || pathName.startsWith(`${hrefPath}/`)
}


  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return path !== '/checkout' && <HeaderSkeleton />
  }
  return (
    path !== '/checkout' && (
      <>
        <header
          id="header"
          className={`w-full ${isLaptop && !isVisible && !openSearch ? '-translate-y-full' : ''}`}

        >
          <div className="header_navmenu bg-[#FFF8EB]">
            <div className="site-container">
              <nav className="nav_wrapper relative">
                <div className="m_logo">
                  <Link
                    href="/"
                    onClick={handleLogoClick}
                    className="navbar__logo"
                  >
                    <Image
                      className="m_nav_logo max-w-14 sm:max-w-18 w-full block"
                      src="/images/NewLogo.svg"
                      alt="GoodSugar Logo"
                      width={30}
                      height={30}
                      quality={100}
                    />
                  </Link>
                </div>

                {/* {isDesktopOrLaptop && (
                  <HeaderStorePincode user={user} isloaded={isloaded} />
                )} */}

                {isDesktopOrLaptop && (
                  <ul className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center gap-8 lg:gap-10">
                    {navLinks.map((link) => {
                      const active = isActiveLink(link.href)
                      return (
                        <li key={link.href}>
                          <Link
                            href={link.href}
                            className={`relative text-[16px] transition-colors hover:text-primary whitespace-nowrap ${
                              active
                                ? 'text-primary font-semibold'
                                : 'text-[#1a1a1a]'
                            }`}
                          >
                            {link.label}
                            {active && (
                              <span className="absolute left-0 -bottom-1 w-full h-[2px] rounded-full bg-primary" />
                            )}
                          </Link>
                        </li>
                      )
                    })}
                  </ul>
                )}

                <div className="search_myaccount_wrapper">

                  <HeaderSearch openSearch={openSearch}  setOpenSearch={setOpenSearch}/>
                   <ul className="my-account-wrapper">
                      <li className="my-account-item group">
                        <Link href="/cart" className="my-account-link">
                          <i className="m-icon bag-icon group-hover:bg-primary"></i>

                          <span className="my-account-bag-item">
                            {isloaded && cartCount ? cartCount : 0}
                          </span>
                        </Link>
                      </li>
                    </ul>
                  <div className="flex items-center">
                    <MyAccount user={user} isloaded={isloaded} inline />

                    {!isDesktopOrLaptop && (
                      <button
                        type="button"
                        aria-label="Toggle menu"
                        aria-expanded={menuOpen}
                        onClick={() => setMenuOpen((v) => !v)}
                        className="ml-3 flex flex-col justify-center items-center w-8 h-8 gap-[5px]"
                      >
                        <span
                          className={`block h-[2px] w-6 rounded-full bg-[#1a1a1a] transition-all duration-300 ${
                            menuOpen ? 'translate-y-[7px] rotate-45' : ''
                          }`}
                        />
                        <span
                          className={`block h-[2px] w-6 rounded-full bg-[#1a1a1a] transition-all duration-300 ${
                            menuOpen ? 'opacity-0' : ''
                          }`}
                        />
                        <span
                          className={`block h-[2px] w-6 rounded-full bg-[#1a1a1a] transition-all duration-300 ${
                            menuOpen ? '-translate-y-[7px] -rotate-45' : ''
                          }`}
                        />
                      </button>
                    )}
                  </div>
                </div>
              </nav>
            </div>
            {isDesktopOrLaptop && <HeaderMenu categoryMenu={categoryMenu} />}
            {!isDesktopOrLaptop && menuOpen && (
              <div className="site-container">
                <ul className="flex flex-col border-t border-black/10 py-1">
                  {navLinks.map((link) => {
                    const active = isActiveLink(link.href)
                    return (
                      <li
                        key={link.href}
                        className="border-b border-black/5 last:border-0"
                      >
                        <Link
                          href={link.href}
                          onClick={() => setMenuOpen(false)}
                          className={`block py-3 text-[16px] transition-colors ${
                            active
                              ? 'text-primary font-semibold'
                              : 'text-[#1a1a1a]'
                          }`}
                        >
                          {link.label}
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )}
          </div>
        </header>
      </>
    )
  )
}

export default Header
